"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGeolocation = void 0;
// Re-export the utility function
var GeolocationUtil_1 = require("./GeolocationUtil");
Object.defineProperty(exports, "getGeolocation", { enumerable: true, get: function () { return GeolocationUtil_1.getGeolocation; } });
